import {IconNight, IconSun} from '@flixbus/honeycomb-icons-react';
import {DriverCostFieldConfig} from '@/components/DriverCosts/DriverCostsTable/DriverCostsTable.types';
import {UnitsSystem} from '@/Pages/Common/LocalUnits/types';
import {Country} from '@/Pages/Countries/store/types';

export const getPartnerCostsDriverCostTableConfig = (
  country: Country,
  localUnits: UnitsSystem
): DriverCostFieldConfig[] => {
  return [
    {
      name: `Driver salary - Weekdays`,
      unit: `${country.currency}/h`,
      key: 'daytimeWeekdaysWorkingHourCost',
      icon: IconSun,
      mandatory: true
    },
    {
      name: `Driver salary - Weeknights`,
      unit: `${country.currency}/h`,
      key: 'nighttimeWeekdaysWorkingHourCost',
      icon: IconNight,
      mandatory: true
    },
    {
      name: `Driver salary - Weekend days`,
      unit: `${country.currency}/h`,
      key: 'daytimeWeekendsWorkingHourCost',
      icon: IconSun,
      mandatory: true
    },
    {
      name: `Driver salary - Weekend nights`,
      unit: `${country.currency}/h`,
      key: 'nighttimeWeekendsWorkingHourCost',
      icon: IconNight,
      mandatory: true
    },
    {
      name: 'Driver change cost',
      unit: `${country.currency}/${localUnits.distanceAbbreviation}`,
      key: 'replacementCostPerKm',
      integerDigitsCount: 7
    },
    {
      name: 'Driver change cost',
      unit: `${country.currency}/h`,
      key: 'replacementCostPerHr'
    },
    {
      name: 'Default accommodation cost',
      unit: `${country.currency}/night`,
      key: 'accommodationCostPerNight',
      mandatory: true
    }
  ];
};
